module.exports = __webpack_public_path__ + "img/horizontal_7_3_8011.c86e6f85.png";